import { useState, useRef, useEffect } from 'react';
import getXcolumnJson from "./xcolumn/list";
// import Paging from "@/pcomponents/common/crud/list/paging/paging";
import strFunc from '@/lib/lyg/string';
import DateFunc from '@/lib/lyg/date_func';
import LayerPopup from '@/pcomponents/common/popup/layer/layer_popup';
import my_axios, { get_axios_data } from "@/pcomponents/common/axios";
import ExcelDownComponent from "@/pcomponents/common/excel/down";
import TradeFixDataFunc from "@/pcomponents/common/content/trade/trade_fix/func/data_func";
import SearchArea from "./area/search";
import SumTableArea from "./area/sum_table";
import ListArea from "./area/list";

function TradeFixListArea(props: any) {
  let myProps = {
    ...props
  };
  const xColumnArr = getXcolumnJson();
  const excelDownRef = useRef<any>(null);
  let now_start_y_m_d = DateFunc.get_date_format(new Date(), "Y-m-01");
  let now_end_y_m_d = DateFunc.get_date_format(new Date(), "Y-m-t");
  const [listOpt, setListOpt] = useState({
    ...xColumnArr.list_opt,
    s_memo_like: "",
    s_cust_name_like: "",
    s_is_fix: "",
    s_subject_detail_like: "",
    s_date_type: "a_add_date",
    s_start_date: now_start_y_m_d,
    s_end_date: now_end_y_m_d,
    s_addon_trade_simple: "1",
    s_addon_trade_simple_start_date: now_start_y_m_d,
    s_addon_trade_simple_end_date: now_end_y_m_d,
    "is_paging": "",
  });
  const [infoArr, setInfoArr] = useState<any>([]); // Set rowData to Array of Objects, one Object per Row
  // const [countInfo, setCountInfo] = useState({ "tot": 0 });
  const [select_row_num_arr, set_select_row_num_arr] = useState<any>([]);

  useEffect(() => {
    list({});
  }, []);

  const list = (inData: any) => {
    let change_listOpt = {
      ...listOpt,
      ...inData
    };
    setListOpt(change_listOpt);
    change_listOpt.s_addon_trade_simple_start_date = change_listOpt.s_start_date;
    change_listOpt.s_addon_trade_simple_end_date = change_listOpt.s_end_date;
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/trade/trade_fix/list', change_listOpt, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          setInfoArr(response.data["data"]["info_arr"]);
          // setCountInfo(response.data["data"]["count_info"]);
        } else {

        }
      });
  };

  const get_selected_info_arr = (inData: any) => {
    let opt_obj = {
      info_arr: infoArr,
      select_row_num_arr: select_row_num_arr,
      ...inData
    };
    let selected_arr: any = [];
    for (let i = 0; i < opt_obj.info_arr.length; i++) {
      let row_data = opt_obj.info_arr[i];
      let row_num = i + "";
      if (strFunc.str_in_array(row_num, opt_obj.select_row_num_arr) != -1) {
        selected_arr.push(row_data);
      }
    }
    return selected_arr;
  };

  const goWrite = (inData: any) => {
    let opt_obj = {
      selected_arr: [...infoArr],
      ...inData
    };
    let selected_arr: any = opt_obj.selected_arr;
    if (selected_arr.length === 0) {
      alert("선택없음.");
      return false;
    }
    for (let i = 0; i < selected_arr.length; i++) {
      selected_arr[i]["a_order_num"] = i + 1;
    }
    //입력값검사
    for (let i = 0; i < selected_arr.length; i++) {
      let row_data = selected_arr[i];
      // if (strFunc.is_empty(row_data["a_cust_name"])) {
      //   alert("거래처를 입력하세요.");
      //   return false;
      // } else if (strFunc.is_empty(row_data["a_trade_memo"])) {
      //   alert("내용을 입력해주세요.");
      //   return false;
      // } else if (strFunc.is_empty(row_data["a_money"])) {
      //   alert("금액을 입력해주세요.");
      //   return false;
      // }
    }
    // if (!confirm("저장 하시겠습니까?")) {
    //   return false;
    // }
    let form_data = {
      "data_arr": selected_arr
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/trade/trade_fix/write', form_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          alert("저장 되었습니다.");
          list({});
        } else {
          alert(response.data["msg"]);
        }
      });
  };

  const goDelete = (inData: any) => {
    let opt_obj = {
      select_row_num_arr: select_row_num_arr,
      ...inData
    };

    let selected_arr: any = get_selected_info_arr({
      select_row_num_arr: opt_obj.select_row_num_arr
    });
    if (selected_arr.length === 0) {
      alert("선택없음.");
      return false;
    }

    let able_del_arr: any = [];
    for (let i = 0; i < selected_arr.length; i++) {
      let row_data = selected_arr[i];
      if (!strFunc.is_empty(row_data["a_seq"])) {
        able_del_arr.push(row_data);
      }
    }
    //신규이면서 선택줄인것 없애기
    let new_info_arr: any = [];
    for (let i = 0; i < infoArr.length; i++) {
      let row_data = infoArr[i];
      if (strFunc.is_empty(row_data["a_seq"])) {
        if (strFunc.str_in_array(i, opt_obj.select_row_num_arr) == -1) {
          new_info_arr.push(row_data);
        }
      } else {
        new_info_arr.push(row_data);
      }
    }
    setInfoArr(new_info_arr);

    if (able_del_arr.length === 0) {
      return false;
    }

    if (!confirm("삭제하시겠습니까?")) {
      return false;
    }
    let form_data = {
      "data_arr": able_del_arr
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/trade/trade_fix/delete', form_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          set_select_row_num_arr([]);
          alert(response.data["msg"]);
          list({});
        } else {
          alert(response.data["msg"]);
        }
      });
  };

  const add_row = (inData: any) => {
    let opt_obj = {
      row_data: {},
      ...inData
    };

    let new_row_data: any = {
      ...TradeFixDataFunc.default_info_data,
      "a_ymd": DateFunc.get_date_format(new Date(listOpt.s_start_date), "Ymd"),
      "a_add_date": listOpt.s_start_date,
      ...opt_obj.row_data,
    };
    new_row_data["a_order_num"] = infoArr.length + 1;
    let new_info_arr = [...infoArr];
    new_info_arr.push(new_row_data);
    setInfoArr(new_info_arr);
    set_select_row_num_arr([
      ...select_row_num_arr,
      new_info_arr.length - 1
    ]);
  };

  const write_trade_by_ajax = (inData: any) => {
    let opt_obj = {
      selected_arr: get_selected_info_arr({}),
      ...inData
    };
    let selected_arr = opt_obj.selected_arr;
    //걸러낸다
    for (let i = 0; i < selected_arr.length; i++) {
      let row_data = selected_arr[i];
      if (strFunc.is_empty(row_data["a_seq"])) {
        alert("저장이 필요합니다.");
        return false;
      }
      if (strFunc.is_empty(row_data["a_cust_name"])) {
        alert("거래처를 입력하세요." + row_data["a_trade_memo"]);
        return false;
      } else if (strFunc.is_empty(row_data["a_trade_memo"])) {
        alert("내용을 입력해주세요.");
        return false;
      } else if (strFunc.is_empty(row_data["a_money"])) {
        alert("금액을 입력해주세요." + row_data["a_trade_memo"]);
        return false;
      }
    }
    if (selected_arr.length == 0) {
      alert("선택된 데이터가 없습니다.");
      return false;
    }

    if (confirm("선택내용을 결산 하시겠습니까?") == false) {
      return false;
    }

    let fix_seq_arr = [];
    for (let i = 0; i < selected_arr.length; i++) {
      let row_data = selected_arr[i];
      fix_seq_arr.push(row_data["a_ymd"] + "," + row_data["a_seq"]);
    }

    let form_data = {
      "trade_fix_seq_arr": fix_seq_arr,
      "s_start_date": listOpt.s_addon_trade_simple_start_date,
      "s_end_date": listOpt.s_addon_trade_simple_end_date
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/trade/trade_fix/add_trade_by_fix', form_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          alert(response.data["msg"]);
          list({});
        } else {
          alert(response.data["msg"]);
        }
      });
  };

  const delete_trade_pay_by_ajax = (inData: any) => {
    let opt_obj = {
      selected_arr: get_selected_info_arr({}),
      ...inData
    };
    let selected_arr = opt_obj.selected_arr;
    let del_trade_arr = [];
    for (let i = 0; i < selected_arr.length; i++) {
      let row_data = selected_arr[i];
      if (row_data["trade_arr"] && row_data["trade_arr"].length > 0) {
        for (let j = 0; j < row_data["trade_arr"].length; j++) {
          del_trade_arr.push(row_data["trade_arr"][j]);
        }
      }
    }
    if (del_trade_arr.length == 0) {
      alert("삭제할 데이터가 없습니다.");
      return false;
    }
    if (confirm("지출 거래를 삭제하시겠습니까?") == false) {
      return false;
    }

    let form_data = {
      "data_arr": del_trade_arr
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/trade/trade_simple/delete', form_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          alert(response.data["msg"]);
          list({});
        } else {
          alert(response.data["msg"]);
        }
      });
  };

  const go_excel_down_list = () => {
    if (excelDownRef.current) {
      excelDownRef.current.setInitData({
        xColumnArr: xColumnArr,
        is_add_example: false,
        infoArr: infoArr,
        excelFileName: "지출내역" + DateFunc.get_date_format(new Date(), "Ymd_his"),
      });
      setTimeout(() => {
        excelDownRef.current.goDownExcel();
      }, 100);
    }
  };

  const add_from_pre_month_by_ajax = (inData: any) => {
    let opt_obj = {
      "from_date_str": DateFunc.get_date_format(DateFunc.get_change_date(new Date(listOpt.s_start_date),'month',-1),"Y-m-d"),
      "to_date_str": listOpt.s_start_date,
      ...inData
    };

    if(!confirm("전 월("+opt_obj["from_date_str"].substring(0,7)+")의 데이터를 가져오시겠습니까?")){
      return;
    }

    let form_json_data = {
      "from_date_str": opt_obj["from_date_str"],
      "to_date_str": opt_obj["to_date_str"],
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/trade/trade_fix/add_from_pre_month', form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          alert(response.data["msg"]);
          list({});
        } else {
          alert(response.data["msg"]);
        }
      });
  };

  return (
    <div>
      <SearchArea
        listOpt={listOpt}
        setListOpt={setListOpt}
        list={list}
      ></SearchArea>
      <SumTableArea
        infoArr={infoArr}
      ></SumTableArea>
      <div className="text-center mt-1">
        <button className="btn btn-dark"
          onClick={() => {
            goWrite({});
          }}
        >저장</button>
        <button className="btn btn-sky ml-1"
          onClick={() => {
            add_row({});
          }} >추가</button>
        <button className="btn btn-red ml-1"
          onClick={() => {
            goDelete({});
          }}>삭제</button>
        <button className='btn btn-gray ml-1' onClick={() => { go_excel_down_list(); }}>엑셀다운</button>
        <button className='btn btn-gray ml-1' onClick={()=>{add_from_pre_month_by_ajax({});}}>전월에서가져오기</button>
        <button className="btn btn-blue ml-2" onClick={() => { write_trade_by_ajax({}); }} >결산</button>
      </div>
      <div className="mt-1">
        <ListArea
          xColumnArr={xColumnArr}
          infoArr={infoArr}
          setInfoArr={setInfoArr}
          select_row_num_arr={select_row_num_arr}
          set_select_row_num_arr={set_select_row_num_arr}
          write_trade_by_ajax={write_trade_by_ajax}
          delete_trade_pay_by_ajax={delete_trade_pay_by_ajax}
          goWrite={goWrite}
          goDelete={goDelete}
        ></ListArea>
        {/* <Paging now_page={listOpt.now_page}
          num_per_page={listOpt.num_per_page}
          total_rec={countInfo.tot}
          onChangePage={(now_page: number) => { list({ now_page: now_page }); }}
          onChangeNumPerPage={(num_per_page: number) => { list({ num_per_page: num_per_page, now_page: 1 }); }}></Paging> */}
      </div>
      <ExcelDownComponent
        ref={excelDownRef}
        xColumnArr={xColumnArr}
        is_add_example={false}
      ></ExcelDownComponent>
    </div>
  );
};
export default TradeFixListArea;